import React from "react";

const TableAdapter = ({ spec, containerRef }) => {
  const { config = {}, data = [] } = spec;
  if (!data || !data.length) {
    return <div className="text-muted p-3 text-center">No data available</div>;
  }

  const columns =
    config.columns ||
    Object.keys(data[0] || {}).map((key) => ({
      key,
      label: key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " "),
    }));

  return (
    <div ref={containerRef} className="assistant-chart-render-wrapper table-render-wrapper table-responsive">
      <table className="table table-hover table-striped assistant-data-table align-middle mb-0">
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx} scope="col">
                {col.label || col.key}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rIdx) => (
            <tr key={rIdx}>
              {columns.map((col, cIdx) => (
                <td key={cIdx}>
                  {typeof row[col.key] === "object" && row[col.key] !== null
                    ? JSON.stringify(row[col.key])
                    : String(row[col.key] ?? "-")}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableAdapter;
